import { MultiSelect, Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { GeneratorOverview } from "../../../../../../utils/backend-types";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";
import { updateRowData } from "./updateRowData";

function getGeneratorColumn(
  generators: Array<GeneratorOverview>,
  creationError: string | null,
  editingError: string | null,
  selectedGeneratorsForCreating: Array<number>,
  onSelectedGeneratorsChange?: (generatorIds: Array<number>) => void
): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "generator",
    header: "Erzeuger",
    size: 300,
    Cell: ({ cell }) => {
      const generatorId = cell.getValue();
      const generator = generators.find((g) => g.id === generatorId);
      return generator ? generator.name : "Unbekannt";
    },
    Edit: ({ table, row }) => {
      if (generators.some((g) => !g.id)) {
        return null;
      }
      const isCreatingRow = row.id === table.getState().creatingRow?.id;
      const generatorData = generators.map((generator) => ({
        value: (generator.id || "").toString(),
        label: generator.name || "Unbekannt"
      }));
      const label = "Erzeuger auswählen";

      if (isCreatingRow) {
        // creating row allows multiple Erzeuger
        return (
          <MultiSelect
            aria-label={`${label} (Mehrfachauswahl)`}
            data={generatorData}
            error={creationError}
            placeholder={`${label} (Mehrfachauswahl)`}
            value={selectedGeneratorsForCreating.map(String)}
            onChange={(values) => {
              const newGenerator =
                values.length > 0
                  ? generators.find((g) => g.id === parseInt(values[0], 10))
                  : null;
              updateRowData({
                table,
                row,
                columnIds: ["generator", "generatorDisplayName"],
                newValues: [
                  newGenerator && newGenerator.id ? newGenerator.id : null,
                  newGenerator && newGenerator.name ? newGenerator.name : null
                ]
              });
              // Track selected generators separately
              onSelectedGeneratorsChange?.(values.map((v) => Number(v)));
            }}
          />
        );
      }

      // defaultValue for integrated Select doesn't work, therefore a manual implementation
      return (
        <Select
          aria-label={label}
          data={generatorData}
          defaultValue={
            row.original.generator
              ? row.original.generator.toString()
              : undefined
          }
          error={editingError}
          placeholder={label}
          onChange={(value) => {
            const newGenerator = value
              ? generators.find((g) => g.id === parseInt(value, 10))
              : null;
            updateRowData({
              table,
              row,
              columnIds: ["generator", "generatorDisplayName"],
              newValues: [
                newGenerator && newGenerator.id ? newGenerator.id : null,
                newGenerator && newGenerator.name ? newGenerator.name : null
              ]
            });
          }}
        />
      );
    }
  };
}

export { getGeneratorColumn };
